import Image from 'next/image';
import styled from 'styled-components';

import { getNameFontSize } from '@/components/ui/Avatar/Avatar.helpers';
import { Typography } from '@/components/ui/Typography/Typography.styles';
import { flexCenterAligned } from '@/styles/common';

export const AvatarWrapper = styled.div<{
  $size: number;
  $withImage?: boolean;
}>`
  ${flexCenterAligned}
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ $withImage }) => !$withImage && 'var(--bg-tertiary)'};
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
`;

export const AvatarImage = styled(Image)`
  object-fit: cover;
`;

export const AvatarName = styled(Typography).attrs({
  htmlTag: 'p'
})<{
  $size: number;
}>`
  font-size: ${({ $size }) => `${getNameFontSize($size)}px`};
  font-weight: 700;
  color: var(--title-snackbar);
`;
